



















import Vue from 'vue'
export default Vue.extend({
  name: 'CurrentBatchDisplay',
  props: {
    currentBatch: {
      type: Number,
      required: true
    },
    totalBatches: {
      type: Number,
      required: true
    }
  }
})
